// The tab's title, per page.
//
// The shell ships a real title (vite.config.ts) and the account worker rewrites
// it per seed and per profile before the HTML leaves (worker/share-meta.ts), so
// a crawler already sees the right one. This is for the person in the tab: a
// page that knows what it is says so, and puts back what it found on the way
// out. A page that doesn't call this leaves the shell's title alone — which is
// why nothing sets a title at boot.

import { useEffect } from "react";

/** What every page's title ends with. */
export const SITE_TITLE = "Seedbed";

/**
 * Sets `document.title` to `<name> · Seedbed` while this page is mounted.
 * An empty name is a page still loading: the title is left as it is until it
 * knows, rather than flashing the site name.
 */
export function useDocumentTitle(name: string): void {
  useEffect(() => {
    if (!name) return;
    const previous = document.title;
    document.title = `${name} · ${SITE_TITLE}`;
    return () => {
      document.title = previous;
    };
  }, [name]);
}
